import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { _SESION_AUTHENTICATED } from '../../data/store/session/sesion.selectors';

export const autenticatedGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(_SESION_AUTHENTICATED).pipe(
    map(status => {
      if (!status) {
        return true;
      }
      return router.createUrlTree(['/']);
    })
  );
};
